export default __webpack_public_path__ + "static/media/topIcon.2e371280.png";